export default "__VITE_ASSET__Pz4tMOFe__"